<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                <span *ngIf="!slide" class="mr-2">Commission Report</span>
                <span *ngIf="slide" class="mr-2">Commission Report - Completed</span>
                <mat-slide-toggle  (change)="slide = !slide" >
                </mat-slide-toggle>
            </div>
        </div>
    </div>
    <div class="card card_content">
        <div class="row d-flex justify-content-center" [formGroup]="commissionForm">
            <div class="col-md-12 ml-3 ">
                <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>First Name</mat-label>
                    <input matInput appInputtext maxlength="25" formControlName="firstName"
                        placeholder="Enter first name" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Last Name</mat-label>
                    <input matInput appInputtext maxlength="25" formControlName="lastName"
                        placeholder="Enter last name" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Account Number</mat-label>
                    <input matInput  maxlength="25" formControlName="customerReferenceNumber"
                        placeholder="Enter account number" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Application Number</mat-label>
                    <input matInput  maxlength="25" formControlName="applicationReferenceNumber"
                        placeholder="Enter application number"  class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4 date_picker">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label *ngIf="!slide">Start Date</mat-label>
                    <mat-label *ngIf="slide">Completed Start Date</mat-label>
                    <input readonly matInput appInputtext [matDatepicker]="picker1" id="picker1" formControlName="approvedApplicationstartdate"
                        autocomplete="off" placeholder="Enter Start Date" class="col-12" class="custom-input-border"
                        (click)="openDatePicker('SDclickId')" specialIsAlphaNumeric [max]="toMaxDate">
                    <mat-datepicker-toggle [id]="'SDclickId'" matSuffix [for]="picker1" style="color:black;">
                        <button mat-icon-button>
                            <mat-icon>event</mat-icon>
                        </button>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4 date_picker">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label *ngIf="!slide">End Date</mat-label>
                    <mat-label *ngIf="slide">Completed End Date</mat-label>
                    <input readonly matInput appInputtext [matDatepicker]="picker2" id="picker2" formControlName="approvedApplicationEnddate"
                        autocomplete="off" placeholder="Enter End Date" class="col-12" class="custom-input-border"
                        (click)="openDatePicker('EDclickId')" specialIsAlphaNumeric [min]="toMinDate" [max]="toMaxDate">
                    <mat-datepicker-toggle [id]="'EDclickId'" matSuffix [for]="picker2" style="color:black;">
                        <button mat-icon-button>
                            <mat-icon>event</mat-icon>
                        </button>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <ng-multiselect-dropdown formControlName="serviceProviderIdList" [placeholder]=""
                    placeholder="Select Service Provider" [settings]="dropdownSettings" [data]="ServiceProviderList">
                </ng-multiselect-dropdown>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <ng-multiselect-dropdown formControlName="applicationStatuslist" [placeholder]=""
                    placeholder="Select Application Status" [settings]="dropdownSettings" [data]="ApplicationStatusList">
                </ng-multiselect-dropdown>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <ng-multiselect-dropdown formControlName="resellerCodeList" [placeholder]="" placeholder="Select Reseller Code"
                    [settings]="dropdownSettings" [data]="ResellerCodeList">
                </ng-multiselect-dropdown>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <ng-multiselect-dropdown formControlName="salesRepCodelist" [placeholder]="" placeholder="Select Sales Code"
                    [settings]="dropdownSettings" [data]="SalesCodeList">
                </ng-multiselect-dropdown>
            </div>
            <div class="col-sm-12 col-md-10 mt-4">
                <mat-checkbox formControlName="applicationCancelRestrict">Cancellation Status</mat-checkbox>
            </div>


        </div>
        <div class="row mt-2 text-center">
            <div class="col-md-12">
                <button type="button" class="btn btn-primary text-nowrap" (click)="Submit()">
                    <i class="fa fa-file-excel"></i> Generate Report
                </button>
            </div>
        </div>
    </div>
</div>
